// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Button base styles */
.button {
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: var(--radius-sm);
  min-width: 120px;
  padding: 8px 16px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* Button variants */
.button-primary {
  background-color: var(--accent);
  color: var(--text-on-accent);
}

.button-primary:disabled {
  background-color: var(--surface-3);
  color: var(--text-tertiary);
  cursor: not-allowed;
}

.button-secondary {
  background-color: transparent;
  color: var(--accent);
  border: 1px solid var(--accent-ring);
}

.button-secondary:hover:not(:disabled) {
  background-color: var(--accent-softer);
  border-color: var(--accent);
}

.button-secondary:disabled {
  color: var(--text-tertiary);
  border-color: var(--border-subtle);
  cursor: not-allowed;
}

.button-text {
  background-color: transparent;
  color: var(--accent);
  min-width: auto;
  padding: 4px 8px;
}

.button-text:hover:not(:disabled) {
  background-color: var(--accent-softer);
}

.button-text:disabled {
  color: var(--text-tertiary);
  cursor: not-allowed;
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .button {
    min-width: 100px;
    padding: 6px 12px;
    border-radius: var(--radius-sm);
  }
  
  .button-text {
    padding: 3px 6px;
  }
}

/* Small mobile devices */
@media (max-width: 480px) {
  .button {
    min-width: 80px;
    padding: 5px 10px;
    border-radius: var(--radius-sm);
  }
  
  .button-text {
    padding: 2px 4px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Button/Button.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,oBAAoB;AACpB;EACE,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Button base styles */\n.button {\n  border: none;\n  outline: none;\n  cursor: pointer;\n  border-radius: var(--radius-sm);\n  min-width: 120px;\n  padding: 8px 16px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n/* Button variants */\n.button-primary {\n  background-color: var(--accent);\n  color: var(--text-on-accent);\n}\n\n.button-primary:disabled {\n  background-color: var(--surface-3);\n  color: var(--text-tertiary);\n  cursor: not-allowed;\n}\n\n.button-secondary {\n  background-color: transparent;\n  color: var(--accent);\n  border: 1px solid var(--accent-ring);\n}\n\n.button-secondary:hover:not(:disabled) {\n  background-color: var(--accent-softer);\n  border-color: var(--accent);\n}\n\n.button-secondary:disabled {\n  color: var(--text-tertiary);\n  border-color: var(--border-subtle);\n  cursor: not-allowed;\n}\n\n.button-text {\n  background-color: transparent;\n  color: var(--accent);\n  min-width: auto;\n  padding: 4px 8px;\n}\n\n.button-text:hover:not(:disabled) {\n  background-color: var(--accent-softer);\n}\n\n.button-text:disabled {\n  color: var(--text-tertiary);\n  cursor: not-allowed;\n}\n\n/* Mobile responsive styles */\n@media (max-width: 768px) {\n  .button {\n    min-width: 100px;\n    padding: 6px 12px;\n    border-radius: var(--radius-sm);\n  }\n  \n  .button-text {\n    padding: 3px 6px;\n  }\n}\n\n/* Small mobile devices */\n@media (max-width: 480px) {\n  .button {\n    min-width: 80px;\n    padding: 5px 10px;\n    border-radius: var(--radius-sm);\n  }\n  \n  .button-text {\n    padding: 2px 4px;\n  }\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
